import React, {useEffect, useRef} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export interface CaptchaProps {
  siteKey: string;
  dataHook?: string;
  onGetApi: Function;
  onChange(token: string | null): void;
}

export const Captcha = (props: CaptchaProps) => {
  const apiRef = useRef<ReCAPTCHA>(null);

  useEffect(() => {
    if (apiRef.current !== null) {
      props.onGetApi(apiRef.current);
    }
  }, [props]);

  const {siteKey, dataHook, onChange} = props;

  // @ts-ignore
  return <ReCAPTCHA data-hook={dataHook} sitekey={siteKey} theme="light" onChange={onChange} ref={apiRef} />;
};
